import { Outlet } from "react-router-dom";
import { Users, MessageSquare, Archive } from "lucide-react";
import { TopNav } from "@/components/TopNav";
import { Footer } from "@/components/Footer";

const links = [
  { to: "/admin", id: "admin-users", label: "Utenti & Sessioni", icon: Users, end: true },
  { to: "/admin/chat", id: "admin-chat", label: "Chat", icon: MessageSquare },
  { to: "/admin/archivio", id: "admin-archive", label: "Archivio Lavori", icon: Archive },
];

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-[#FBFBFC] flex flex-col">
      <TopNav links={links} home="/admin" sub="Super Admin" dark />
      <main className="flex-1 w-full max-w-[1400px] mx-auto px-4 sm:px-8 py-8 sm:py-12">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
